import { motion } from "motion/react";
import { cn } from "./utils";
import React from "react";

interface SparklingStarProps {
  className?: string; // For positioning and size
  duration?: number;
  delay?: number;
  children: React.ReactNode;
}

export function SparklingStar({ 
  className, 
  duration = 3, 
  delay = 0, 
  children 
}: SparklingStarProps) {
  return (
    <motion.div 
      className={cn("absolute", className)}
      animate={{ 
        scale: [1, 1.1, 1], 
        opacity: [0.8, 1, 0.8] 
      }}
      transition={{ 
        duration, 
        repeat: Infinity, 
        ease: "easeInOut", 
        delay 
      }}
    >
      {children}
    </motion.div>
  );
}
